import type { Person } from '@local/common-lib';
import { ArrowBack as CancelIcon, Save as SaveIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { CardActions, CardContent, Grid } from '@mui/material';
import type { FC } from 'react';
import { FormikRolesControl } from '../../components/formik-fields/roles-control.js';
import { FormikTextField } from '../../components/formik-fields/text-field.js';
import { CenterCard } from '../../components/page-layout/center-card.js';
import type { EditViewProps } from '../../utils/types.js';

export const EditView: FC<EditViewProps<Person.Create | Person.Patch>> = ({
  cancel,
  formik,
}) => {
  return (
    <form onReset={formik.handleReset} onSubmit={formik.handleSubmit}>
      <CenterCard>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <FormikTextField
                autoFocus={true}
                formik={formik}
                id="firstName"
                label="First name"
                required
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormikTextField
                formik={formik}
                id="lastName"
                label="Last name"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormikTextField
                formik={formik}
                id="email"
                label="Email address"
                required
                type="email"
              />
            </Grid>
            <Grid item xs={12}>
              <FormikTextField
                formik={formik}
                id="phone"
                label="Phone"
                type="tel"
              />
            </Grid>
            <Grid item xs={12}>
              <FormikRolesControl formik={formik} id="roles" />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions sx={{ justifyContent: 'space-between', pb: 3 }}>
          <LoadingButton
            color="primary"
            loading={formik.isSubmitting}
            onClick={cancel}
            startIcon={<CancelIcon />}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            color="primary"
            loading={formik.isSubmitting}
            startIcon={<SaveIcon />}
            type="submit"
            variant="contained"
          >
            Save
          </LoadingButton>
        </CardActions>
      </CenterCard>
    </form>
  );
};
